// Translation strings
import af from '@/lang/af';
import ar from '@/lang/ar';
import de from '@/lang/de';
import en from '@/lang/en';
import en_AU from '@/lang/en_AU';
import en_GB from '@/lang/en_GB';
import es from '@/lang/es';
import es_MX from '@/lang/es_MX';
import fil from '@/lang/fil';
import fr from '@/lang/fr';
import fr_CA from '@/lang/fr_CA';
import hi from '@/lang/hi';
import it from '@/lang/it';
import ja from '@/lang/ja';
import ms from '@/lang/ms';
import pl from '@/lang/pl';
import pt_BR from '@/lang/pt_BR';
import pt_PT from '@/lang/pt_PT';
import ru from '@/lang/ru';
import th from '@/lang/th';
import tr from '@/lang/tr';
import zh_CN from '@/lang/zh_CN';
import zu from '@/lang/zu';

export default {
  af,
  ar,
  de,
  en,
  'en-AU': en_AU,
  'en-GB': en_GB,
  es,
  'es-MX': es_MX,
  fil,
  fr,
  'fr-CA': fr_CA,
  hi,
  it,
  ja,
  ms,
  pl,
  'pt-BR': pt_BR,
  'pt-PT': pt_PT,
  ru,
  th,
  tr,
  'zh-CN': zh_CN,
  zu
}
